<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
.action-butn-resize-wrap{display: flex; justify-content: flex-start; align-items: center; flex-wrap: wrap;}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Crop Photo</h3>
    </div>
    <vs-alert color="danger" title="Photo Not Found" :active.sync="photowall_not_found">
      <span>Photo not found.</span>
      <span>
        <span>Check</span>&nbsp;
        <router-link :to="{name:'photowalls'}" class="text-inherit underline">Back to List</router-link>
      </span>
    </vs-alert>
    <div class="content" v-show="!photowall_not_found">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="16 / 9"
            :src="imgSrc"
            preview=".preview"
          />
        </div> 
        <!-- <textarea v-model="data" />  -->

      </section>
      <section class="preview-area">
        <p class="mt-0">Preview</p>
        <div class="preview" />
        <!--
        <p>Cropped Image</p>
        <div class="cropped-image">
          <img
            v-if="cropImg"
            :src="cropImg"
            alt="Cropped Image"
          />
          <div v-else class="crop-placeholder" />
        </div>
        -->
        <div class="actions action-butn-resize-wrap">
          <a
            href="#"
            role="button"
            @click.prevent="zoom(0.2)"
          >
            Zoom In
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="zoom(-0.2)"
          >
            Zoom Out
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="move(-10, 0)"
          >
            Move Left
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="move(10, 0)"
          >
            Move Right
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="move(0, -10)"
          >
            Move Up
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="move(0, 10)"
          >
            Move Down
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="rotate(90)"
          >
            Rotate +90deg
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="rotate(-90)"
          >
            Rotate -90deg
          </a>
          <a
            ref="flipX"
            href="#"
            role="button"
            @click.prevent="flipX"
          >
            Flip X
          </a>
          <a
            ref="flipY"
            href="#"
            role="button"
            @click.prevent="flipY"
          >
            Flip Y
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="reset"
          >
            Reset
          </a>
          <!--
          <a
            href="#"
            role="button"
            @click.prevent="cropImage"
          >
            Crop
          </a>          
          <a
            href="#"
            role="button"
            @click.prevent="getData"
          >
            Get Data
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="setData"
          >
            Set Data
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="getCropBoxData"
          >
            Get CropBox Data
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="setCropBoxData"
          >
            Set CropBox Data
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="showFileChooser"
          >
            Upload Image
          </a>
          -->
        </div>
      </section>
    </div>

      <!-- Save & Reset Button -->
    <div class="vx-row" v-show="!photowall_not_found">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class=" mt-2" @click="$router.push('/event/photowalls')">Back To List</vs-button>
          <vs-button class="ml-auto mt-2" @click="upload_photo">Save Changes</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

// Store Module
import modulePhotowallManagement from "@/store/photowall-management/modulePhotowallManagement.js";

export default {
  components: {
    VueCropper
  },
  data() {
    return {
      photowall_data: null,
      photowall_not_found: false,
      imgSrc: null,
      cropImg: '',
      data: null,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    
  },
  methods: {
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    /*setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },*/
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    getFileName(downloadUrl){
      let url = decodeURIComponent(downloadUrl)
      let arr = url.split('?');
      let arr2 = arr[0].split('/')
      let name = arr2[arr2.length - 1]
      return name
    },
    upload_photo(){
      this.$vs.loading()
      let cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      let json = JSON.stringify(cropImg, null, 2);
      let blob = new Blob([json], { type: "image/png" });
      let photowall_data = this.photowall_data
      let name = this.getFileName(photowall_data.photoUrl)
      console.log("name======",name);
       console.log("photowall_data======",photowall_data);
       console.log("data_url======",cropImg.toString());
        console.log("name======",name);
      this.$store
          .dispatch("photowallManagement/upload_resizePhoto", {
            photowall_data: photowall_data,
            blob: blob,
            data_url: cropImg.toString(),
            name: name
          })
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              position: 'top-center',
              title: 'Photo Wall',
              text: "Photo Uploaded"
            })
            this.$vs.loading.close() 
            if (res.status == 200) {
              this.$router.push('/event/photowalls');             
            }
          })
    }
    
  },
  created() {
    if(this.$route.params.row)
    {
      this.photowall_data = this.$route.params.row
      this.imgSrc = this.$route.params.row.photoUrl
    }
    else
      this.photowall_not_found = true

  }
};
</script>

<style>

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
    width: 614px;
    border: 1px solid #cbcbcb;
    margin-top: 50px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 400px;
  margin-top: 41px;
  position: relative;
}
.preview-area:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 1px;
    background: #cbcbcb;
    right: 100%;
    top: 0;
    margin-right: 21px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>